import { render, staticRenderFns } from "./add-trial.vue?vue&type=template&id=60e58e3c"
import script from "./add-trial.vue?vue&type=script&lang=js"
export * from "./add-trial.vue?vue&type=script&lang=js"
import style0 from "./add-trial.vue?vue&type=style&index=0&id=60e58e3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports